var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=assignment_FILL1 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6 6.3C32.3 6.3 32.9001 6.6 33.4001 7.1C33.9001 7.6 34.2 8.2 34.1 8.9V32C34.1 32.7 33.8 33.3 33.3 33.8C32.8 34.4 32.2001 34.6 31.5 34.6H8.40005C7.70005 34.6 7.10005 34.3 6.60005 33.8C6.10005 33.3 5.80005 32.7 5.80005 32V8.9C5.80005 8.2 6.10005 7.6 6.60005 7.1C7.10005 6.6 7.70005 6.3 8.40005 6.3H16.6C16.6 5.4 16.9 4.7 17.6 4C18.2 3.3 19 3 20 3C20.9 3 21.7 3.3 22.4 4C23.1 4.6 23.4 5.4 23.4 6.3H31.6ZM20 7.6C20.4 7.6 20.7 7.5 21 7.2C21.2 6.9 21.4 6.6 21.4 6.2C21.4 5.9 21.3 5.6 21 5.3C20.7 5 20.4 4.9 20 4.9C19.6 4.9 19.3 5 19 5.3C18.7 5.5 18.6 5.8 18.6 6.2C18.6 6.6 18.7 6.9 19 7.2C19.3 7.5 19.6 7.6 20 7.6ZM12.5 26.1002L14.1 27.7002L20 21.7002L25.9 27.7002L27.5 26.1002L21.6 20.2002L27.5 14.3002L25.9 12.7002L20 18.6002L14.1 12.7002L12.5 14.3002L18.4 20.2002L12.5 26.1002Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInComplete);
export default __webpack_public_path__ + "static/media/inComplete.627b6a549e23fec4f2e7d584db3b2c48.svg";
export { ForwardRef as ReactComponent };